<template>
  <v-bottom-sheet v-model="isActive" persistent>
    <v-card>
      <div class="modal-header">
        <p class="title mb-0">Histórico de alterações</p>
      </div>
      <section class="logs-container">
        <v-card v-if="logsByDate.length" class="timeline-card pl-0 pr-0" flat>
          <div class="day" v-for="(dateLog, index) in logsByDate" :key="index">
            <v-card class="mb-0 mt-0 pt-0 pb-0 pl-0 pr-0" flat>
              <v-container class="day-container">
                <v-layout align-center>
                  <strong class="month-day mr-4 capitalize">{{ dateLog.day }}</strong>
                  <v-layout column justify-end>
                    <div class="title text-capitalize">{{ dateLog.dayOfWeek }}</div>
                    <div class="month-year text-capitalize">{{ `${dateLog.month} ・ ${dateLog.year}` }}</div>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
            <v-card-text class="py-0">
              <v-timeline dense v-for="(log, index) in dateLog.logs" :key="`${log.id}-modal-interval-logs-${index}`">
                <v-timeline-item color="#fff" small>
                  <v-layout>
                    <v-flex>
                      <strong style="color: #4a5568">{{ log.description }}</strong>
                      <div class="caption">
                        <strong style="color: #a0aec0">{{ getTime(log.created_at) }}</strong>
                        <span style="color: #a0aec0"> · {{ log.user.name }}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-timeline-item>
              </v-timeline>
            </v-card-text>
          </div>
        </v-card>
      </section>
      <div class="modal-footer">
        <v-btn class="custom-btn" elevation="0" block @click="close">Voltar</v-btn>
      </div>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import TaskService from '@/services/api/task';

export default {
  name: 'ModalIntervalLogs',
  emits: ['close'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      logsByDate: [],
      logDescriptions: {
        created: 'Tarefa criada',
        deleted: 'Tarefa deletada',
        change_start_date: 'Data inicial alterada',
        change_end_date: 'Data final alterada'
      }
    };
  },
  computed: {
    taskToShowIntervalsHistory() {
      return this.$store.getters['ServiceOrderTask/getTaskToShowIntervalsHistory'];
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async getTaskLogs() {
      if (!this.taskToShowIntervalsHistory) return;

      try {
        this.$store.dispatch('ServiceOrderTask/setLoading', true);

        const { data } = await TaskService.getTaskLogs(this.taskToShowIntervalsHistory.id);
        this.logsByDate = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.$store.dispatch('ServiceOrderTask/setLoading', false);
      }
    },
    capitalized(string) {
      const capitalizedFirst = string[0].toUpperCase();
      const rest = string.slice(1);

      return capitalizedFirst + rest;
    },
    getDayNumber(date) {
      return date.split('/')[0];
    },
    getDayName(date) {
      const day = date.split('/')[0];
      const month = date.split('/')[1];
      const year = date.split('/')[2];

      const dateToCompare = new Date(`${year}-${month}-${day} 12:00:00`);

      const dayName = dateToCompare.toLocaleDateString('pt-BR', { weekday: 'long' });

      return this.capitalized(dayName);
    },
    getMonthNameAndYear(date) {
      const month = date.split('/')[1];
      const year = date.split('/')[2];

      const dateToCompare = new Date(`${year}-${month}-03`);

      const monthName = dateToCompare.toLocaleDateString('pt-BR', { month: 'long' });

      return `${monthName} de ${year}`;
    },
    getTime(dateTime) {
      const dataObj = new Date(dateTime);

      return dataObj.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  },
  watch: {
    isActive(newValue) {
      if (newValue) {
        this.getTaskLogs();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-card {
  padding: 16px 16px 24px 16px;

  .modal-header {
    margin-bottom: 0;

    .title {
      color: #2d3748;
      font-size: 18px;
      font-weight: 600;
      text-align: center !important;
      width: 100%;
      padding-bottom: 8px;
    }
  }

  .modal-footer {
    position: absolute;
    bottom: 0;
    padding-bottom: 18px;
    padding-top: 18px;
    z-index: 100;
    background-color: #fff;
    width: 93%;

    .custom-btn {
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      height: 40px;
      letter-spacing: 0.3px;
      text-transform: none;
      width: 48%;

      border: 1px solid #e2e8f0;
      background-color: #fff;
      color: #4a5568;
    }
  }
}

.logs-container {
  height: 70vh;
  overflow-y: auto;
}

.day-container {
  background: #f0eff5;
  padding: 12px 24px 12px 48px;

  .month-day {
    font-size: 24px;
    font-weight: 700;
    color: #2d3748;
  }

  .title {
    font-weight: 500;
    font-size: 16px;
    color: #4a5568;
  }

  .month-year {
    color: #a0aec0;
    font-weight: 300;
    font-size: 16px;
  }
}

.timeline-card {
  margin-top: 3px;
}
</style>
